var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x82\xB1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M41.792 20.224H36.416C36.032 37.952 28.8 46.912 22.208 51.84C20.8 52.992 18.88 54.144 17.024 54.848L22.464 58.496C33.92 51.264 41.216 39.936 41.792 20.224Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    d: "M39 20C39 41 28 53.5 18 57.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    d: "M17.664 22.528L18.304 17.536H52.544C54.08 17.536 56.64 17.472 58.496 17.152V22.656C56.512 22.528 54.016 22.528 52.544 22.528H17.664Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_2",
    d: "M17.5 20H58.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    d: "M20.16 5.37601L26.368 6.528C25.792 8 25.216 9.728 24.704 11.072C23.744 13.952 22.272 17.856 20.48 21.376C17.984 26.368 13.248 32.832 9.28 36.224L4.224 33.152C8.832 29.888 13.376 23.296 15.616 19.392C17.344 16.192 18.496 12.928 19.2 10.432C19.712 8.832 20.032 7.04 20.16 5.37601Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_3",
    d: "M23.5 5.5C19.7121 19.9711 15.4307 26.8655 6 35.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKe);
export default __webpack_public_path__ + "static/media/ke.bb5e2db614f4b4fc3a70f9f5c38509c3.svg";
export { ForwardRef as ReactComponent };